import React from 'react';
import PropTypes from 'prop-types';
import { AlertTriangle, Building2, Database, Package } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { LOW_STOCK_THRESHOLD } from '../utils';

const AdminStocksStats = ({ stats }) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Éléments suivis</CardTitle>
          <Package className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.total}</div>
          <p className="mt-1 text-xs text-muted-foreground">
            Tous les objets avec stock connu
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Stock faible</CardTitle>
          <AlertTriangle className="h-4 w-4 text-amber-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.lowStock}</div>
          <p className="mt-1 text-xs text-muted-foreground">
            Stock entre 1 et {LOW_STOCK_THRESHOLD}
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Ruptures</CardTitle>
          <Database className="h-4 w-4 text-red-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.outOfStock}</div>
          <p className="mt-1 text-xs text-muted-foreground">
            Éléments avec stock à 0
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-sm font-medium">Service Desks</CardTitle>
          <Building2 className="h-4 w-4 text-muted-foreground" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{stats.serviceDeskCount}</div>
          <p className="mt-1 text-xs text-muted-foreground">
            Providers actifs sur les desks configurés
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

AdminStocksStats.propTypes = {
  stats: PropTypes.shape({
    total: PropTypes.number.isRequired,
    lowStock: PropTypes.number.isRequired,
    outOfStock: PropTypes.number.isRequired,
    serviceDeskCount: PropTypes.number.isRequired,
  }).isRequired,
};

export { AdminStocksStats };
